import styled from "styled-components";

export const Styled = styled.div`
  display: flex;
  position: relative;
  min-width: 150px;
  .tailwind-css-ui-components {
    width: 100%;
  }
  .dropdown-options-container {
    width: 120%;
    span {
      overflow: hidden;
      text-overflow: ellipsis;
      margin-right: 5px;
    }
    i[name="checked-circle"] {
      min-width: 16px;
    }
  }
`;
